import { useCallback, useState } from 'react';

import { FormikProvider, useFormik } from 'formik';
import { v4 as uuidv4 } from 'uuid';

import type { IProductForm } from './types';
import useValidationSchema from './useValidationSchema';

export default function ProductFormFields({
  onSubmit,
  product,
  isDebtOwner,
  isEdit = false,
  children,
}: IProductForm) {
  const [generatedInternalId, setGeneratedInternalId] = useState<string>(uuidv4());

  const productSchema = useValidationSchema(isDebtOwner);
  const initialValues = productSchema.cast(
    {
      internalOrderId: generatedInternalId,
      ...product,
    },
    { assert: false },
  );

  const resetInitialValues = useCallback(() => {
    setGeneratedInternalId(uuidv4());
  }, [setGeneratedInternalId]); // Generate new id on reset

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    initialValues: initialValues,
    initialTouched: { ...(isEdit && { paymentTerms: { paymentTermsCode: true } }) },
    validationSchema: productSchema,
    onSubmit: (data) => {
      onSubmit(data, () => resetInitialValues());
    },
  });

  return (
    <FormikProvider value={formik} key={generatedInternalId}>
      <form autoComplete="off" onSubmit={formik.handleSubmit}>
        {children}
      </form>
    </FormikProvider>
  );
}
